<template>
  <div :class="prefixCls">
    <Tree-node
      v-for="(item, i) in stateTree"
      :key="i"
      :data="item"
      visible
      :multiple="multiple"
      :show-checkbox="showCheckbox"
      :show-arrow-next="showArrowNext"
      :show-user-count="showUserCount"
      :children-key="childrenKey">
    </Tree-node>
    <div :class="[prefixCls + '-empty']" v-if="!stateTree.length">{{emptyText}}</div>
  </div>
</template>
<script>
import TreeNode from './TreeNode.vue'
import Emitter from '../mixins/emitter'

const prefixCls = 'tree'
// https://www.iviewui.com/components/tree
export default {
  name: 'Tree',
  mixins: [ Emitter ],
  components: { TreeNode },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: ''
    },
    childrenKey: {
      type: String,
      default: 'children'
    },
    showArrowNext: {
      type: Boolean,
      default: false
    },
    showUserCount: {
      type: Boolean,
      default: false
    },
    loadData: {
      type: Function
    },
    render: {
      type: Function
    }
  },
  data () {
    return {
      prefixCls: prefixCls,
      stateTree: this.data,
      flatState: []
    }
  },
  watch: {
    data: {
      deep: true,
      handler () {
        this.stateTree = this.data
        this.flatState = this.compileFlatState()
        this.rebuildTree()
      }
    }
  },
  computed: {
  },
  methods: {
    compileFlatState () { // so we have always a relation parent/children of each node
      let keyCounter = 0
      let childrenKey = this.childrenKey
      const flatTree = []
      function flattenChildren (node, parent) {
        node.nodeKey = keyCounter++
        flatTree[node.nodeKey] = { node: node, nodeKey: node.nodeKey }
        if (typeof parent !== 'undefined') {
          flatTree[node.nodeKey].parent = parent.nodeKey
          flatTree[parent.nodeKey][childrenKey].push(node.nodeKey)
        }
        if (node[childrenKey]) {
          flatTree[node.nodeKey][childrenKey] = []
          node[childrenKey].forEach(child => flattenChildren(child, node))
        }
      }
      this.stateTree.forEach(rootNode => {
        flattenChildren(rootNode)
      })
      return flatTree
    },
    // updateTreeUp (nodeKey) {
    //   const parentKey = this.flatState[nodeKey].parent
    //   if (typeof parentKey === 'undefined') return

    //   const node = this.flatState[nodeKey].node
    //   const parent = this.flatState[parentKey].node
    //   if (node.checked == parent.checked && node.indeterminate == parent.indeterminate) return // no need to update upwards

    //   if (node.checked == true) {
    //     this.$set(parent, 'checked', parent[this.childrenKey].every(node => node.checked))
    //     this.$set(parent, 'indeterminate', !parent.checked)
    //   } else {
    //     this.$set(parent, 'checked', false)
    //     this.$set(parent, 'indeterminate', parent[this.childrenKey].some(node => node.checked || node.indeterminate))
    //   }
    //   this.updateTreeUp(parentKey)
    // },
    rebuildTree () { // only called when `data` prop changes
      const checkedNodes = this.getCheckedNodes()
      checkedNodes.forEach(node => {
        this.updateTreeDown(node, {checked: true})
        // propagate upwards
        // const parentKey = this.flatState[node.nodeKey].parent
        // if (!parentKey && parentKey !== 0) return
        // const parent = this.flatState[parentKey].node
        // const childHasCheckSetter = typeof node.checked !== 'undefined' && node.checked
        // if (childHasCheckSetter && parent.checked != node.checked) {
        //   this.updateTreeUp(node.nodeKey) // update tree upwards
        // }
      })
    },

    getSelectedNodes () {
      /* public API */
      return this.flatState.filter(obj => obj.node.selected).map(obj => obj.node)
    },
    getCheckedNodes () {
      /* public API */
      return this.flatState.filter(obj => obj.node.checked).map(obj => obj.node)
    },
    updateTreeDown (node, changes = {}) {
      for (let key in changes) {
        this.$set(node, key, changes[key])
      }
      // if (node[this.childrenKey]) {
      //   node[this.childrenKey].forEach(child => {
      //     this.updateTreeDown(child, changes)
      //   })
      // }
    },
    handleSelect (nodeKey) {
      const node = this.flatState[nodeKey].node
      if (!this.multiple) { // reset previously selected node
        const currentSelectedKey = this.flatState.findIndex(obj => obj.node.selected)
        if (currentSelectedKey >= 0 && currentSelectedKey !== nodeKey) this.$set(this.flatState[currentSelectedKey].node, 'selected', false)
      }
      // this.$set(node, 'selected', !node.selected)
      // 只能选中 不能取消选中
      this.$set(node, 'selected', true)

      this.$emit('on-select-change', this.getSelectedNodes())
    },
    handleCheck ({ checked, nodeKey }) {
      const node = this.flatState[nodeKey].node
      this.$set(node, 'checked', checked)
      this.$set(node, 'indeterminate', false)

      // this.updateTreeUp(nodeKey) // propagate up
      this.updateTreeDown(node, {checked, indeterminate: false}) // reset `indeterminate` when going down

      // 新增了一个只返回选中节点事件
      this.$emit('on-item-check-change', node)
      this.$emit('on-check-change', this.getCheckedNodes())
    }
  },
  created () {
    this.flatState = this.compileFlatState()
    this.rebuildTree()
  },
  mounted () {
    this.$on('on-check', this.handleCheck)
    this.$on('on-selected', this.handleSelect)
    this.$on('toggle-expand', node => this.$emit('on-toggle-expand', node))
  }
}
</script>
<style lang="postcss">
@import 'variables';

.tree {
  & .tree-empty {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid var(--sepLineColor);
  }

  & .tree-title {
    height: 50px;
    display: flex;
    font-size: 16px;
  }

  & .van-checkbox {
    margin-right: 10px;
    flex: 0 0 auto;
  }

  & .tree-arrow {
    margin-right: 7px;

    & .iconfont {
      display: inline-block;
      width: 16px;
      text-align: center;
    }
  }

  & .icon-arrow-right {
    font-size: 12px;
    transition: all .2s ease-in-out;

    &.unvisiable {
      visibility: hidden;
    }
  }

  & .tree-arrow-open {
    & .icon-arrow-right {
      transform: rotate(90deg);
    }
  }

  & .tree-arrow-disabled {
    & .icon-arrow-right {
      color: #dbdcdd;
    }
  }

  & .content {
    border-bottom: 1px solid var(--sepLineColor);
    flex: 1 1 auto;
    display: flex;
    overflow: hidden;
    padding-right: 10px;

    & .name {
      flex: 1 1 auto;
      display: flex;
    }

    & .icon-arrow-next {
      flex: 0 0 auto;
    }

    & .user-count {
      color: var(--secondlyText);
      padding-left: 10px;
    }
  }

  & .icon-arrow-next {
    color: #b2b7ca;
    flex: 0 0 auto;
  }

  & ul {
    margin: 0;
    padding: 0;
  }

  & li {
    line-height: 50px;

    & ul {
      padding: 0;
      margin: 0 0 0 18px;
    }
  }
}

.load-loop:before {
  display: inline-block;
  animation: rotation 2s linear infinite;
}
</style>
